// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3CTLO","calendarButtons":"ClockData_calendarButtons__WHUf4"};